<div class="card main-card mb-3">
    <div class="card-header">
        Purchase intents {{ !!segmentId ? '(segment ' + segmentId + ')' : '' }}
    </div>
    <div class="card-body">
        <canvas baseChart
            [data]="chartData"
            [labels]="chartLabels"
            [chartType]="chartType"
            [options]="chartOptions"
            [plugins]="chartPlugins"
            [colors]="chartBackgroundColors"
            [legend]="chartLegend">
        </canvas>
    </div>
</div>